import HideAdButton from './HideAdButton';

export default HideAdButton;
